import { getMenuStatusMeta } from "../../services/menuOverviewModel";

const statusTextClass = {
  success: "text-secondary",
  warning: "text-amber-700",
  neutral: "text-gray-400",
};

export default function MenuListGrid({ menus, activeMenuId, onSelect }) {
  return (
    <div
      className="flex gap-1 overflow-x-auto border-b border-gray-200 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      role="tablist"
      aria-label="فهرست منوها"
    >
      {menus.map((menu) => {
        const statusMeta = getMenuStatusMeta(menu.status || (menu.isActive ? "published" : "disabled"));
        const active = String(menu._id) === String(activeMenuId);

        return (
          <button
            key={menu._id}
            type="button"
            role="tab"
            onClick={() => onSelect(menu._id)}
            aria-selected={active}
            className={`-mb-px flex shrink-0 items-center gap-2 border-b-2 px-3 py-2.5 text-sm transition-colors focus:outline-none focus-visible:bg-gray-50 ${
              active
                ? "border-secondary font-bold text-accent"
                : "border-transparent font-medium text-gray-500 hover:text-accent"
            }`}
          >
            <span className="max-w-40 truncate">{menu.title || "بدون عنوان"}</span>
            <span className={`text-[11px] font-medium ${statusTextClass[statusMeta.tone] || statusTextClass.neutral}`}>
              {statusMeta.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
